import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { EnaioCertificatesTools } from '../../shared/enaio-certificates-tools';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    isClassRegisterEditor = false;
    isCertificateEditor = false;
    isPupilListEditor = false;
    isFinalExamEditor = false;

    async initParams(): Promise<boolean> {
        this.fullScreenComponent = false;
        this.isClassRegisterEditor = this.service.isClassRegisterEditor();
        this.isCertificateEditor = this.service.isCertificateEditor();
        let settings = await this.service.restGetClassRegisterSettings(EnaioCertificatesTools.getCurrentYear(), false);
        this.isPupilListEditor = this.service.isPupilListEditor(settings);
        this.isFinalExamEditor = this.service.isFinalExamEditor(settings);
        this.app.updateNavigation("Schulportal", []);        
        return true;
    }
}
